import { Button, Tooltip, useMediaQuery } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosLogOut } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Swal from "sweetalert2";
import ResponsiveNavbar from "../../components/navbarMobile/ResponsiveNavbar";
import "../../pages/comman.scss";
import { resetKycDetails } from "../../redux/features/kycDetailsSlice";
import { getProfileApi, resetProfile } from "../../redux/features/profileSlice";
import sidebarLinks from "../../utils/sidebarLinks";
import "./Dashboard.css";
import { useEffect } from "react";
import { decryptFields, encryptFields } from "../../utils/kycStatus";
import axiosInstance from "../../utils/axiosInstance";
import Footer from "../../components/footer/Footer";
import DashboardFooter from "../../components/DashboardFooter";

const drawerWidth = 230;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Dashboard() {
  const location = useLocation();
  const dispatch = useDispatch();

  let userDetails;
  try {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  } catch (error) {
    console.error("Error parsing userDetails:", error);
  }
  const userId = userDetails?._id;

  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const Token = sessionStorage.getItem("token");
  React.useEffect(() => {
    // const login = localStorage.getItem("isLOGIN");
    if (!Token) {
      navigate("/login");
    }
  }, []);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const callLogoutAPI = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });

    if (result.isConfirmed) {
      try {
        const res = await axiosInstance.post("/logout");

        if (res.status === 200) {
          dispatch(resetProfile());
          dispatch(resetKycDetails());

          sessionStorage.clear();
          localStorage.clear();
          navigate("/login");
        }

        return res.data;
      } catch (error) {
        Swal.fire({
          title: "Logout failed",
          text: "An error occurred while logging you out.",
          icon: "error",
          confirmButtonColor: "#3085d6",
        });
        throw error;
      }
    }
  };

  const [hoveredIndex, setHoveredIndex] = React.useState(null);
  const isMobile = useMediaQuery("(max-width:700px)");

  useEffect(() => {
    dispatch(getProfileApi());
  }, [dispatch]);

  const profileSliceResponse = useSelector(
    (state) => state?.profileSlice?.data?.data
  );

  useEffect(() => {
    if (profileSliceResponse?.length) {
      const { pan_no, account_no } = profileSliceResponse?.[0]?.kyc || {};

      const billingData =
        profileSliceResponse?.[0]?.billingAddress?.[0] ||
        profileSliceResponse?.[0]?.billAddressUser ||
        {};

      const { city, line1, line2, state } = billingData;

      let userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

      userDetails = decryptFields(userDetails, ["pan", "bank", "address"]);

      if (pan_no != null && pan_no !== "") {
        userDetails.pan = true;
      }

      if (account_no != null && account_no !== "") {
        userDetails.bank = true;
      }

      if (city && line1 && line2 && state) {
        userDetails.address = true;
      }

      userDetails = encryptFields(userDetails, ["pan", "bank", "address"]);

      localStorage.setItem("userDetails", JSON.stringify(userDetails));
    }
  }, [profileSliceResponse]);

  return (
    <Box sx={{ display: "flex" }}>
      {/* -----------------------------------NAVBAR--------------------------------------------  */}
      <AppBar position="fixed" open={open}>
        <Toolbar sx={{ bgcolor: "#fff", color: "#c62128" }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {!isMobile && (
                <Button
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  edge="start"
                  sx={{
                    marginRight: 1,
                  }}
                >
                  <GiHamburgerMenu />
                </Button>
              )}
              {/* {isMobile && <NavbarMobile />} */}
              {!open && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* <Link to="/account">
                    <img
                      src="/images/BajajLogo.png"
                      alt="Batuk"
                      width="130"
                      style={{ width: "172px", height: "26px" }}
                    />
                  </Link> */}
                </div>
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Tooltip title="Logout">
                <Button variant="text" onClick={callLogoutAPI}>
                  {/* <Avatar sx={{ backgroundColor: "#F3F2EE", color: "white" }} /> */}
                  <IoIosLogOut color="black" size={30} />
                </Button>
              </Tooltip>
              {isMobile && <ResponsiveNavbar />}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {/* ------------------------------------SIDEBAR-------------------------------------- */}
      {!isMobile && (
        <Drawer variant="permanent" open={open}>
          <DrawerHeader
            sx={{
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <Link to="/account">
              <img
                src="/images/BajajLogo.png"
                alt="batuk"
                width="130px"
                style={{ width: "172px", height: "26px" }}
              />
            </Link> */}
          </DrawerHeader>
          <Divider />
          {sidebarLinks.map((item, index) => (
            <NavLink
              to={item.link}
              key={index}
              // className={({ isActive }) =>
              //   isActive ? "sidebar_active_link" : "sidebar-link"
              // }

              className={() => {
                if (item.type === "home") return "sidebar-link";

                // Handle special case where "gold" should not be active on "gold-sip"
                if (
                  item.type === "gold" &&
                  location.pathname.startsWith("/dashboard/gold-sip")
                )
                  return "sidebar-link";

                if (
                  item.type === "silver" &&
                  location.pathname.startsWith("/dashboard/silver-sip")
                )
                  return "sidebar-link";

                // Active condition for items with `active` path
                if (item.active && location.pathname.startsWith(item.active)) {
                  return "active-link";
                }

                // Fallback to normal matching
                return location.pathname.startsWith(item.link)
                  ? "active-link"
                  : "sidebar-link";
              }}
            >
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <Tooltip title={open ? "" : item.name} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={
                          window.location.pathname === item.link ||
                          hoveredIndex === index
                            ? item.img2 || item.img
                            : item.img
                        }
                        alt={item.name}
                        width={30}
                      />
                    </ListItemIcon>
                    <h5
                      style={{
                        alignItems: "center",
                        display: open ? "" : "none",
                        margin: "0px",
                      }}
                    >
                      {item.name}
                    </h5>
                  </ListItemButton>
                </Tooltip>
              </ListItem>
            </NavLink>
          ))}
        </Drawer>
      )}

      <Box
        component="main"
        className="dashboard_child_container"
        // style={{ maxWidth: "1240px", margin: "auto" }}
      >
        <div style={{ padding: "2rem 1rem 2rem 1rem" }}>
          <div style={{ maxWidth: "1240px", margin: "auto" }}>
            <DrawerHeader />
            <Outlet />
          </div>
        </div>

        <div>
        {/* <Footer /> */}

        {/* <DashboardFooter /> */}
        </div>
      </Box>
    </Box>
  );
}
